import { html } from 'lit';
import type { TemplateResult } from 'lit';
import { playIcon, pauseIcon } from './icons';
import { formatTimecode } from './waveform';

export interface TransportCallbacks {
  onToggle: () => void;
}

export function renderTransport(
  isPlaying: boolean,
  currentTimeS: number,
  durationS: number,
  loading: boolean,
  disabled: boolean,
  cb: TransportCallbacks,
): TemplateResult {
  const label = isPlaying ? 'Pause demo' : 'Play demo';
  const timecode = `${formatTimecode(currentTimeS)} / ${formatTimecode(durationS)}`;
  return html`
    <div class="transport">
      <button
        class="play-btn"
        type="button"
        aria-label=${label}
        aria-pressed=${isPlaying ? 'true' : 'false'}
        ?disabled=${disabled}
        @click=${cb.onToggle}
      >
        ${loading
          ? html`<span class="spinner" aria-hidden="true"></span>`
          : isPlaying
          ? pauseIcon
          : playIcon}
      </button>
      <span class="timecode" aria-hidden="true">${timecode}</span>
    </div>
  `;
}
